import {
  getClientList,
  getClientById,
  addClient,
  deleteClientAPI
} from '../../../services/DCR/DCRService';

export const fetchDcrClients = async (clientFilterDetails) => {
  try {
    const response = await getClientList(clientFilterDetails);

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching clients list',
        variant: 'error'
      });
      console.log('Error fetching clients list:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching clients list',
      variant: 'error'
    });
    console.log('Error fetching clients list:', err);
    return [];
  }
};

export const fetchDcrClientsById = async (clientGUID) => {
  try {
    const response = await getClientById(clientGUID);

    if (response && response.success) {
      return response.data;
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching clients details',
        variant: 'error'
      });
      console.log('Error fetching clients details:', response?.message);
      return null;
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching clients details',
      variant: 'error'
    });
    console.log('Error fetching clients details:', err);
    return null;
  }
};

export const saveDcrClient = async (payload, customSuccessMsg, customErrorMsg) => {
  try {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    const apiPayload = {
      ...payload,
      ...{
        createdGUID: user.userGUID,
        modifiedGUID: user.userGUID,
        createdDate: new Date(),
        modifiedDate: new Date()
      }
    };
    const response = await addClient(apiPayload);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save client');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save client`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Client saved successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save client');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save client:', err);
    return { success: false, message: errorMessage };
  }
};

export const deleteDcrClient = async (clientGUID, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await deleteClientAPI(clientGUID);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save client');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save client`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Client Deleted successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save client');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save client:', err);
    return { success: false, message: errorMessage };
  }
};
